export default "__VITE_ASSET__1mcy1bte__"